// @flow
import { COUNTRY_INTRODUCTION } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_COMMON_COUNTRY_INTRODUCTION } from 'Utils/request/requestDictionary';

export const countryIntroductionResolver = {
  name: COUNTRY_INTRODUCTION,
  resolve(appContext: AppContext, props: { countryId: string, isForFamily: boolean } = {}) {
    const { countryId, isForFamily } = props;
    const countryArgs = `countryId:"${countryId}" isForFamily:${isForFamily.toString()}`;

    const query = `query {
      countryInfos(${countryArgs}) {
        title
        description
      }
      config {
        common {
          viewMore
          loadLess
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_COMMON_COUNTRY_INTRODUCTION,
      strictErrors: false,
    });
  },
};
